import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Tab, NavItem, Nav } from 'react-bootstrap';
import { SECTIONS_DATA, TOOLS } from '../igroadmap_components/constants';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router';
import {
  STARTUP_SECTIONS,
  STARTUP_SECTION_ICON
} from '../igmvp_components/models/constants';
import {
  BUSINESS_APPS,
  DASHBOARD_TYPES
} from '../dashboard_components/constants';
import { BMC_BLOCKS } from '../common_components/bmc/bmc_constants';

export const BLOCKS_FOR_STARTUP_SECTION = {
  [STARTUP_SECTIONS.INFRASTRUCTURE]: BMC_BLOCKS.KEY_PARTNERS,
  [STARTUP_SECTIONS.CUSTOMER_R]: BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
  [STARTUP_SECTIONS.MONETIZATION]: BMC_BLOCKS.COST_STRUCTURE
};

@withRouter
@injectIntl
@observer
export default class extends React.Component {
  changeTo = section => {
    const {
      intl,
      location: { pathname },
      history
    } = this.props;

    history.push(
      pathname
        .replace(new RegExp(Object.values(STARTUP_SECTIONS).join('|')), section)
        .replace(
          new RegExp(Object.values(BMC_BLOCKS).join('|')),
          BLOCKS_FOR_STARTUP_SECTION[section]
        )
    );
  };

  render() {
    const {
      intl,
      location: { pathname }
    } = this.props;

    if (
      !(
        Object.values(STARTUP_SECTIONS).some(sec => pathname.includes(sec)) &&
        pathname.includes('dashboards')
      )
    ) {
      return null;
    }

    const lineWidth = `${100 - 100 / Object.values(STARTUP_SECTIONS).length}%`;

    return (
      <Tab.Container id="tabs">
        <Row>
          <Col xs={12} className="wizard product">
            <div className="wizard-inner">
              <div className="connecting-line" style={{ width: lineWidth }} />
              <Nav className="nav-tabs">
                {Object.values(STARTUP_SECTIONS).map(section => (
                  <NavItem
                    onClick={() => {
                      this.changeTo(section);
                    }}
                    style={{
                      width: `${100 / Object.values(STARTUP_SECTIONS).length}%`
                    }}
                  >
                    <span className="round-tab">
                      <h5 className="text-icon">
                        {intl.formatMessage({ id: section })}
                      </h5>
                      <i className={STARTUP_SECTION_ICON[section]} />
                    </span>
                  </NavItem>
                ))}
              </Nav>
            </div>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}
